import configDefault from "./config-default";

const config = {
	...configDefault,
	code: 'accrosport.fr',
	appClassName: 'ACCROSPORT',
	analytics: {
		gtag: 'G-F2BB2LW6PZ',
		gtm: 'GTM-TLX8QTP'
	},
	htmlCustomCSS: "accrosport.scss",
	favicon: '/accrosport-favicon.png',
	title: "Je m'inscris | Accrosport",
	companyName: "Accrosport",
	website: 'https://accrosport.com/',
	notifyChannel: 'vel-accrosport',
	header: {
		title: "Je m'abonne",
		logo: "/accrosport-logo-header.png",
	},
	footer: {
		logo: "/accrosport-logo.png",
		cgv: {
			link: 'https://accrosport.com/cgv/',
			text: 'CGV'
		}
	},
	promoCode: false,
	payByCard: "PAYLINE",
	choice: {
		selectLabel: 'Sélectionner',
		selectedLabel: 'Sélectionné',
		mandatoryLabel: "Inclus",
		nameColor: '#000000',
		border: '#EFECEC',
		border_selected: 'lightgray',
		background: 'white',
		footerBg: '#EFECEC',
		footerBg_selected: '#f7f7f7',
		checkboxSelected: '#6FD181'
	},
	errorCode: {
		...configDefault.errorCode,
		"api.error.sale.contact-invalid-data":"Veuillez essayer avec une autre adresse mail ou contacter le club directement.",
		default: "Une erreur est survenue avec Resamania2",
	},
	sign : {
		title: 'Signature du contrat',
		placeholder: "Code reçu par SMS",
		explain: "Entrer ici le code reçu par SMS pour signer le contrat",
		resendCodeLabel: "Renvoyer le code",
		badCodeLabel: "Code incorrect",
		signLabel: "Valider la signature",
	},
	payment: {
		...configDefault.payment,
		loadingLabel: "Vérification en cours",
		informationLabel: "Informations de paiement",
		resumeLabel: "Total à payer par CB: ",
		payLabel: "Payer ",
		errorLabel: "Nous avons un soucis avec votre paiment.",
		errorTitle: "Une erreur est survenue",
	},
	loadingDefault: "Chargement en cours",
	loadingSmsCodeCheck: 'Vérification du code',
	loadingSmsCodeSend: 'Envoi du SMS',
	loadingTextUserCreation: "Création de votre compte",
	loadingTextCartCreation: "Création de votre panier",
	loadingTextAddressCheck: "Vérification de votre adresse",
	loadingTextOffersLoad: "Chargement des offres",
	plans: {
		...configDefault.plans,
		noPlanFoundTitle: "Aucune formule",
		noPlanFoundTexts : [
			"Nous n'avons trouvé aucune formule pour ce club,",
			"veuillez réessayer plus tard ou changer de club via l'étape 1"
		],
		useImg : 'withText',
		beforeUser: false,
		imageBaseURL: 'https://api.resamania.com',
		title: "JE CHOISIS MA FORMULE",
		// splitCounterAbo: {
		// 	subsText : ["En illimité", "Dès 39€"],
		// 	passText: ['A la séance', "Dès 5€"]
		// },
		incitation: "Je choisis ma formule",
		feesLabel : "Carte membre",
		nofeesLabel: "Pas de frais de carte membre",
		autoSubmit: false,
		nextLabel: "Suivant",
		order: (plans) => {
			const result = [];
			const rest = [];
			plans.forEach( p => {
				if( p.name === 'Strong ') {
					result[0] = p;
				} else if( p.name === 'Athletic ') {
					result[1] = p;
				} else if( p.name === 'Mega Athletic ') {
					result[2] = p;
				} else if( p.name === 'Flow ') {
					result[3] = p;
				} else if( p.name === 'Performance ') {
					result[4] = p;
				} else {
					rest.push(p)
				}
			})
			return [...result, ...rest].filter( e => e)
		}
	},
	productsLoader : {
		errorTitle: "Une erreur est survenue avec Resamania2",
		errorText: 'Veuillez réessayer plus tard ou avec un autre club',
	},
	options: {
		title: "Choisissez vos options",
		nextLabel: "Suivant",
		useImg : 'withText',
		imageBaseURL: 'https://api.resamania.com',
		message: "Un doute sur le choix de tes options ? Rien de grave, tu pourras avoir des infos ultérieurement directement à l’accueil de ton club.",
		mandatoriesAreExcludedFromFreeChoice: true
	},
	regulars : {
		title: "OPTIONS ET EQUIPEMENTS",
		useImg : 'withText',
		imageBaseURL: 'https://api.resamania.com',
		message: "Commandez ici, votre article est à l’accueil.",
		nextLabel: "Suivant",
	},
	recap: {
		title: "Ma sélection",
		myOffer: "Ma formule",
		offerExplanation: "Le montant indiqué comprend votre carte membre + le montant au pro-rata de la semaine en cours. Ensuite, vous serez prélevé toutes les 4 semaines, le mercredi comme expliqué dans votre contrat (cf étape suivante)",
		myCounter: "Mes options et équipements",
		nextLabel: "Je confirme",
		payByCardLabel: "Total à payer par carte",
		payBySepaLabel : "Total prélevé directement",
	},
	sepa : {
		title: "RIB - Paiement Mensuel",
		validateLabel : "J’accepte par la présente les prélèvements automatiques SEPA",
		explain: "Veuillez mettre votre RIB ci-dessous pour valider votre abonnement et signer votre mandat de prélèvement SEPA",
		ownerLabel: "Titulaire du compte",
		ibanLabel: "IBAN",
		bicLabel: "BIC",
		bankLabel: "Nom de la banque",
	},
	contract: {
		title: "Votre contrat",
		signLabel: "Signer le contrat",
	},
	confirmation: {
		welcomeLabel: "Bienvenue chez",
		text: "Votre adhésion a bien été prise en compte, vous recevrez un e-mail de confirmation sous peu.",
		backLabel: "Retour au site."
	},
	steps: {
		display: {
			showShortNames: true,
		},
		clubSelect: {
			noAddress: false,
			showMap: "Masquer la carte",
			hideMap: "Voir la carte",
			title: 'JE CHOISIS MON CLUB',
			nextLabel: "Suivant",
			withMap: false,
			searchable:false,
			sameLine: true,
			autoSelect: true,
		},
		userForm: {
			...configDefault.steps.userForm,
			nextLabel: "Suivant",
			genderLabel: 'Civilité',
			gender_F: "Mme",
			gender_M: "M.",
			firstnameLabel: 'Prénom',
			lastnameLabel: "Nom",
			emailLabel: 'Adresse e-mail',
			phoneLabel: "Nº de téléphone portable",
			phoneExplain: "Utilisé pour la signature du contrat et du mandat SEPA",
			birthdateLabel: "Date de naissance",
			addressLabel: "Adresse",
			backLabel: "Retour",
			noClub: true,
			noGender: false,
			noAddress: false,
			noBirthdate: false,
			title: "MES COORDONNÉES",
			optins: {
				...configDefault.steps.userForm.optins,
				acceptLegal: {
					text: "J’ai lu et j'accepte les conditions générales",
					moreLabel: "Voir les CGV",
					href: 'https://accrosport.com/cgv/',
					step: 1,
					required: true,
				}
			}
		},
	},
	stepsLabels: {
		...configDefault.stepsLabels,
	},
	stepsShortLabels: {
		...configDefault.stepsShortLabels
	},
	rootProperties: {
		'primary': '#6FD181',
		'primary--dark': '#4FB562',
		'placeholder': '#999999',
		'border': '#3d3d3d',
	},
	htmlStyle: `
		html {
			font-weight: 400;
			font-family: 'Funnel Display', 'Inter', sans-serif;
		}
	`,
	theme: {
		primary: '#6FD181',
		stepsDisplay: {
			color: {
				main: '#252525',
				bgFilled: '#252525',
				textFilled: 'white',

				subText: '#252525',
			}
		},
		loader : {
			border: 'black',
			border2: '#6FD181'
		},
		fontFamily: "'Funnel Display', 'Inter', sans-serif",
		buttonPrimary: {
			color: '#6FD181',
			text: '#000',
		},
		buttonOther: {
			color: 'black',
			text: '#fff',
		},
		buttonSecondary: {
			color: "black",
			text: '#fff'
		},
		stepHeader: {
			fontWeight: 800,
			fontSize: "1.25rem",
			textTransform: 'uppercase',
			paddingTop:'1rem'
		}
	}
};

export default config;
